<template>
    <div class="statusMessage">
        <div class="messageWindow">
            <h1 v-bind:class="{ smallFont: message && message.length > 50 }">{{ message }}</h1>
            <div class="exitButton">
                <a v-if="redirect" :href="'/?cat=' + category"><font-awesome-icon icon="home" /></a>
                <a v-if="!redirect" href="#" @click="dismiss">OK</a>
            </div>

        </div>
        
    </div>

    

</template>

<script>

import axios from 'axios'

export default {

    name: 'statusMessage',

    data() {
        return {

            name: '',

        }
    },
    
    props: ['message', 'category', 'redirect'],

    computed: {
        charLimit() {
            return '';
        }
    },

    methods: {
        dismiss() {
            this.$emit("dismiss");
        }
    },

    mounted() {
        
    }

}
</script>


<style scoped>
    .statusMessage {
        position: absolute;
        z-index: 100;
        width: 800px;
        min-height: 480px;

        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;

    }
h1 {
        font-size: 16px !important;
    }
    .messageWindow {
        background: #eee;
        margin: 20px 0;
        border-radius: 10px;
        text-align: center;
        min-width: 400px;
        max-width: 760px;
        color: #000;
        /*margin-top: 500px;*/
    }

    h1 {
        margin: 0;
        text-align: center;
        padding: 20px;
        font-weight: normal;
    }

    .exitButton {
        user-select: none;
        text-align: center;
        background: #fff;
        /*width: 100px;*/
        display: inline-block;
        font-size: 32px;
        margin: 10px auto 40px;
        border: 1px solid #bbb;
        
        border-radius: 5px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.5);
        
        
    }

    a {
        text-decoration: none;
        color: #000;
        display: block;
        
        padding: 10px 30px;

    }

    h1.smallFont {
        font-size: 16px;
    }

</style>
